import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
  Tooltip,
  IconButton,
  TablePagination,
  Box,
} from "@mui/material";
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import CloudDownloadRoundedIcon from '@mui/icons-material/CloudDownloadRounded';
import { PaymentService } from "../../../../../services/payment";
import { IPayment } from "../../../../../interfaces/payments";
import getUrl from "../../../../../functions/getUrl";

interface Fatura {
  uc: string;
  mesAno: string;
  vencimento: string;
  valor: string;
  situacao: string;
}

const faturas: Fatura[] = [
  { uc: "23933704", mesAno: "08/2024", vencimento: "25/09/2024", valor: "R$ 131,11", situacao: "PAGA" },
  { uc: "23933704", mesAno: "07/2024", vencimento: "25/08/2024", valor: "R$ 120,05", situacao: "PAGA" },
  { uc: "23933704", mesAno: "06/2024", vencimento: "25/07/2024", valor: "R$ 70,00", situacao: "PAGA" },
  { uc: "23933704", mesAno: "05/2024", vencimento: "25/06/2024", valor: "R$ 124,71", situacao: "PAGA" },
  { uc: "23933704", mesAno: "04/2024", vencimento: "25/05/2024", valor: "R$ 100,53", situacao: "PAGA" },
  { uc: "23933704", mesAno: "03/2024", vencimento: "25/04/2024", valor: "R$ 74,88", situacao: "PAGA" },
  { uc: "23933704", mesAno: "02/2024", vencimento: "25/03/2024", valor: "R$ 74,79", situacao: "PAGA" },
  { uc: "23933704", mesAno: "01/2024", vencimento: "25/02/2024", valor: "R$ 63,20", situacao: "PAGA" },
];

const instance = new PaymentService();

const TabelaFaturas: React.FC = () => {

    const [rows, setRows] = React.useState([5]);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [page, setPage] = React.useState(0);

    const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
    };
    
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [payments, setPayments] = useState<IPayment[]>([]);

  const getPayments = () => {
    instance.getList()
    .then( res => setPayments(res))
    .catch(error => console.log(error))

  }
  useEffect(() => {
    getPayments();
  }, []);
  useEffect(() => {
    console.log('payments', payments)
  }, [payments]);

  const downloadBoleto = (filename: string) => {
    let url = getUrl("payments", filename);

    window.open(url, "_blank");


  }
  return (
    <Box component={Paper} sx={{ mr: 2}}>
        <TableContainer >
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell>CÓDIGO</TableCell>
                    <TableCell>MÊS/ANO</TableCell>
                    <TableCell>VENCIMENTO</TableCell>
                    <TableCell>VALOR</TableCell>
                    <TableCell>SITUAÇÃO</TableCell>
                    <TableCell>BAIXAR</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {payments.map((fatura, index) => (
                    <TableRow key={index}
                        sx={{
                            cursor: "pointer", // Adiciona um cursor de ponteiro
                            "&:hover": {
                            backgroundColor: "#f5f5f5", // Cor de fundo ao passar o mouse
                            },
                        }}
                    >
                    <TableCell>{fatura.codigo}</TableCell>
                    <TableCell>{fatura.mesAno}</TableCell>
                    <TableCell>{fatura.vencimento}</TableCell>
                    <TableCell>{fatura.valor}</TableCell>
                    <TableCell>
                        <Chip label={fatura.situacao} color="success" variant="filled" icon={<CircleRoundedIcon sx={{ fontSize: "0.7em"}}/>}/>
                    </TableCell>
                    <TableCell>
                        <Tooltip title="Baixar Boleto" color="warning">
                            <IconButton onClick={() => downloadBoleto(fatura.filename)}>
                                <CloudDownloadRoundedIcon/>
                            </IconButton>
                        </Tooltip>
        
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
        <TablePagination
            labelRowsPerPage="Linhas por página:"
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
            }
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </Box>
  );
}
export default TabelaFaturas;
